import { render } from "./ToDoItem.vue?vue&type=template&id=3cea4ca4&scoped=true"
import script from "./ToDoItem.vue?vue&type=script&lang=js"
export * from "./ToDoItem.vue?vue&type=script&lang=js"

import "./ToDoItem.vue?vue&type=style&index=0&id=3cea4ca4&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/derbyweb.dev/selesti-vue-challenge.derbyweb.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cea4ca4"]])

export default __exports__